import React from 'react';
import './ChapterPerformance.css';

function ChapterPerformance({ data }) {
  const medal = (i) => ['🥇','🥈','🥉'][i] || `#${i + 1}`;

  if (!data.length) {
    return <div className="no-data">No chapter data available</div>;
  }

  return (
    <div className="chapter-perf">
      <div className="perf-table-wrap">
        <table className="perf-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Chapter</th>
              <th>State</th>
              <th>Projects</th>
              <th>Contributed</th>
              <th>Beneficiaries</th>
            </tr>
          </thead>
          <tbody>
            {data.map((ch, i) => (
              <tr key={ch.chapterId} className={i < 3 ? 'top3' : ''}>
                <td className="rank">{medal(i)}</td>
                <td className="ch-name">{ch.chapterName}</td>
                <td className="ch-state">{ch.state}</td>
                <td className="num">{ch.projectsSupported}</td>
                <td className="num green">
                  ${(ch.totalContributed / 1000).toFixed(0)}K
                </td>
                <td className="num">{ch.beneficiaries.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ChapterPerformance;
